import { render, staticRenderFns } from "./HomepagePrivateOrder.vue?vue&type=template&id=f861670a&scoped=true&"
import script from "./HomepagePrivateOrder.vue?vue&type=script&lang=js&"
export * from "./HomepagePrivateOrder.vue?vue&type=script&lang=js&"
import style0 from "./HomepagePrivateOrder.vue?vue&type=style&index=0&id=f861670a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f861670a",
  null
  
)

export default component.exports